import { TextField, Typography, withStyles, FormLabel } from '@material-ui/core';
import { ChangeEvent, FC } from 'react';
import { COLOR_TEXT_MAIN } from '../../../theme/colors';

type InputProps = {
  maxLength?: string;
  readOnly?: boolean;
};

type Props = {
  value: string;
  text?: string;
  type?: string;
  id?: string;
  autoComplete?: string;
  isPassword?: boolean;
  error?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  inputProps?: InputProps;
  helperText?: JSX.Element;
  required?: boolean;
  placeholder?: string;
  margin?: string;
  width?: string;
  className?: string;
};

const StyledInputField: FC<Props> = ({
  value,
  text,
  type,
  id,
  autoComplete,
  isPassword,
  error,
  onChange,
  inputProps,
  helperText,
  required = true,
  placeholder,
  margin,
  width,
  className,
}) => {
  return (
    <div className={className} style={{ margin: margin, width: width }}>
      {text ? <StyledFormLabel required={required}>{text ? text : null}</StyledFormLabel> : null}
      <StyledTextField
        id={id}
        autoComplete={autoComplete}
        required={required}
        variant={`outlined`}
        // label={<FormattedMessage id="user_setting.general.name.label" />}
        error={error}
        value={value}
        type={isPassword ? 'password' : type ? type : undefined}
        inputProps={inputProps}
        onChange={onChange}
        placeholder={placeholder}
        style={{
          width: width,
        }}
      />
      {helperText ? (
        <Typography
          style={{
            fontSize: 12,
            margin: '12px 0px',
            color: COLOR_TEXT_MAIN,
          }}
        >
          {helperText}
        </Typography>
      ) : null}
    </div>
  );
};

const StyledTextField = withStyles({
  root: {
    width: `100%`,
    background: '#FFFFFF',
    borderRadius: '8px',
    '& .MuiOutlinedInput-root': {
      color: COLOR_TEXT_MAIN,
      borderRadius: '8px',
      fontSize: '14px',
      height: '48px',
      '& fieldset': {
        borderColor: '#E6E7E8',
      },
      '&:hover fieldset': {
        borderColor: '#E6E7E8',
      },
      '&.Mui-focused fieldset': {
        border: '1.5px solid #666666',
      },
      '&.Mui-error fieldset': {
        border: '1.5px solid #FE7877',
      },
      '&.Mui-error input': {
        color: '#FE7877',
      },
    },
    '& .MuiOutlinedInput-input': {
      padding: '15px 14px',
    },
  },
})(TextField);

const StyledFormLabel = withStyles({
  root: {
    fontWeight: 800,
    fontSize: '12px',
    color: COLOR_TEXT_MAIN,
    textAlign: 'start',
    display: 'block',
    marginBottom: '10px',
    '& .Mui-focused': {
      color: COLOR_TEXT_MAIN,
    },
  },
})(FormLabel);

export default StyledInputField;
